/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFollowAktsRequest
 */
export interface GetFollowAktsRequest {
    /**
     * 
     * @type {number}
     * @memberof GetFollowAktsRequest
     */
    aktid?: number;
}

export function GetFollowAktsRequestFromJSON(json: any): GetFollowAktsRequest {
    return GetFollowAktsRequestFromJSONTyped(json, false);
}

export function GetFollowAktsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFollowAktsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': !exists(json, 'aktid') ? undefined : json['aktid'],
    };
}

export function GetFollowAktsRequestToJSON(value?: GetFollowAktsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
    };
}


